module.exports = __webpack_public_path__ + "fonts/Inter-400-greek-ext45.2d64d8a.woff2";